module.exports = __webpack_public_path__ + "static/media/icon-peaje.77de12cb.svg";